const providers = [
  ['square', 'Square', 'pull the sales summary', 'square-status'],
  ['quickbooks', 'QuickBooks', 'push your invoices into the books', 'quickbooks-status'],
  ['shopify', 'Shopify', 'pull your orders into Mise', 'production-shopify'],
  ['faire', 'Faire', 'pull your orders into Mise', 'wholesale-faire-status'],
  ['gmail', 'Gmail', 'turn operational emails into to-dos', 'gmail-status'],
  ['sevenshifts', '7shifts', 'pull your published schedule into Mise', 'sevenshifts-status'],
  ['ubereats', 'Uber Eats', 'pull the delivery sales summary', 'ubereats-status'],
  ['ramp', 'Ramp', 'pull your spend and bills', 'ramp-status'],
  ['clover', 'Clover', 'pull your recent orders', 'clover-status'],
  ['lightspeed', 'Lightspeed', 'pull your account details', 'lightspeed-status'],
  ['tripleseat', 'Tripleseat', 'pull your events and leads into Events', 'tripleseat-status'],
] as const;

export function readIntegrationOAuthResult(search: string) {
  const params = new URLSearchParams(search);
  // Read the shared reason before removing any provider's callback fields.
  const reason = params.get('reason');
  const notifications: Array<{ tone: 'success' | 'error'; message: string; queryKey: string }> = [];
  for (const [key, label, action, queryKey] of providers) {
    const result = params.get(key);
    if (!result) continue;
    notifications.push({
      tone: result === 'connected' ? 'success' : 'error',
      message: result === 'connected'
        ? `${label} connected — hit Sync now to ${action}.`
        : `${label} connection failed${reason ? `: ${reason}` : ''}.`,
      queryKey,
    });
    params.delete(key);
  }
  if (notifications.length) params.delete('reason');
  return { notifications, search: params.toString() };
}
